import { createBrowserRouter } from "react-router-dom";

// routes
import MainRoutes from "./MainRoutes";
import LoginRoutes from "./LoginRoutes";

//utils
import { getAvailableRoutes } from "routes/utils";

//types
import { Route } from "shared/types";

const createRouter = () =>
  createBrowserRouter(
    [
      LoginRoutes,
      {
        ...MainRoutes,
        children: getAvailableRoutes(MainRoutes?.children || []) as Route[],
      },
    ],

    {
      basename: import.meta.env.VITE_APP_BASE_NAME,
    },
  );

export default createRouter;
